export type AddLocationTab = "locations" | "customLocation";

export function getDefaultLocationTab(
  slid: string,
  customLocation: string,
  withCustomLocations = false,
  customLocations: string[] = []
): AddLocationTab {
  if (slid) return "locations";
  if (customLocation) {
    if (withCustomLocations && customLocations.includes(customLocation)) {
      return "locations";
    }
    return "customLocation";
  }
  return "locations";
}
